import CriticsOverrides from "components/Critics/PodSource/Overrides"
import InputDate from "components/inputs/Date"
import TechSpecsList from "components/TechSpecs/List"

import { ComponentProps } from "."
import OverridesScoreQuoteAndSection from "./OverridesScoreQuoteAndSection"
import {
  OverridesLabel,
  Wrapper as OverridesWrapper
} from "./OverridesScoreQuoteAndSection/styled"
import { OverridesSections, TechSpecs } from "./styled"

const Overrides = ({
  onSetReleaseDate,
  onUpdateAudio,
  onUpdateExtra,
  onUpdateMovie,
  onUpdateTotal,
  onUpdateVideo,
  review,
  serviceName
}: ComponentProps) => (
  <CriticsOverrides>
    <OverridesSections>
      <OverridesScoreQuoteAndSection
        inputId="video"
        label="Video"
        name="video"
        onUpdate={onUpdateVideo}
        quote={review.video?.quote}
        score={review.video?.score}
        section={review.video?.section}
        serviceName={serviceName}
      />

      <OverridesScoreQuoteAndSection
        inputId="audio"
        label="Audio"
        name="audio"
        onUpdate={onUpdateAudio}
        quote={review.audio?.quote}
        score={review.audio?.score}
        section={review.audio?.section}
        serviceName={serviceName}
      />

      <OverridesScoreQuoteAndSection
        inputId="extra"
        label="Extra"
        name="extra"
        onUpdate={onUpdateExtra}
        quote={review.extra?.quote}
        score={review.extra?.score}
        section={review.extra?.section}
        serviceName={serviceName}
      />

      <OverridesScoreQuoteAndSection
        inputId="movie"
        label="Movie"
        name="movie"
        onUpdate={onUpdateMovie}
        quote={review.movie?.quote}
        score={review.movie?.score}
        section={review.movie?.section}
        serviceName={serviceName}
      />

      <OverridesScoreQuoteAndSection
        inputId="total"
        label="Total"
        name="Total"
        onUpdate={onUpdateTotal}
        quote={review.total?.quote}
        score={review.total?.score}
        section={review.total?.section}
        serviceName={serviceName}
      />

      <OverridesWrapper>
        {review.techSpecs ? (
          <TechSpecs>
            <OverridesLabel>{"Tech Specs"}</OverridesLabel>

            <TechSpecsList techSpecs={review.techSpecs} />
          </TechSpecs>
        ) : null}

        <InputDate
          label="Release Date"
          onChange={onSetReleaseDate}
          value={review.releaseDate}
        />
      </OverridesWrapper>
    </OverridesSections>
  </CriticsOverrides>
)
export default Overrides
